import { defineMessages } from 'react-intl';

export default defineMessages({
  breadcrumb: {
    home: {
      id: 'home',
      defaultMessage: 'Home',
    },
    form: {
      id: 'formBuilder',
      defaultMessage: 'Form Builder',
    },
  },
  detail: {
    title: {
      id: 'formBuilder.detail',
      defaultMessage: 'Form Detail',
    },
    preview: {
      id: 'formBuilder.preview',
      defaultMessage: 'Page Preview',
    },
    formConfig: {
      id: 'formBuilder.title',
      defaultMessage: 'Form Configuration',
    },
    id: {
      id: 'formBuilder.detail.id',
      defaultMessage: 'Form ID',
    },
    name: {
      id: 'formBuilder.detail.name',
      defaultMessage: 'Form Name',
    },
    desc: {
      id: 'formBuilder.detail.desc',
      defaultMessage: 'Form Description',
    },
    tag: {
      id: 'formBuilder.detail.tag',
      defaultMessage: 'Tag',
    },
    created: {
      id: 'formBuilder.detail.created',
      defaultMessage: 'Created At',
    },
    updated: {
      id: 'formBuilder.detail.updated',
      defaultMessage: 'Updated At',
    },
  },
  error: {
    delete: {
      id: 'formBuilder.error.delete',
      defaultMessage:
        'This form cannot be deleted as this form is still assigned to some service(s) and/or biller(s)',
    },
  },
  confirmation: {
    title: {
      id: 'formBuilder.confirmation.title',
      defaultMessage: 'Confirmation',
    },
    delete: {
      id: 'formBuilder.confirmation.delete',
      defaultMessage: 'Are you sure want to delete {title} form?',
    },
  },
  btn: {
    edit: {
      id: 'formBuilder.btn.edit',
      defaultMessage: 'Edit',
    },
    cancel: {
      id: 'formBuilder.btn.cancel',
      defaultMessage: 'Cancel',
    },
    discard: {
      id: 'formBuilder.btn.discard',
      defaultMessage: 'Discard Detail',
    },
    save: {
      id: 'formBuilder.btn.save',
      defaultMessage: 'Save',
    },
    add: {
      id: 'formBuilder.btn.add',
      defaultMessage: 'Add New Component',
    },
  },
  billerOfForm: {
    title: {
      id: 'formBuilder.detail.billerOfForm.title',
      defaultMessage: 'Biller under this form',
    },
    pgStatus: {
      id: 'formBuilder.detail.billerOfForm.pgStatus',
      defaultMessage: 'Playground Status',
    },
    skwStatus: {
      id: 'formBuilder.detail.billerOfForm.skwStatus',
      defaultMessage: 'Skywalker Status',
    },
    serviceStatus: {
      id: 'formBuilder.detail.billerOfForm.serviceStatus',
      defaultMessage: 'Service Status',
    },
  },
});
